import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

export const selectAccessLockToken = ($) => $?.access?.lockToken;
export const selectAccessHasLockToken = ($) => fromAnyToBool(selectAccessLockToken($));
export const selectAccessPerms = ($) => $?.access?.perms;

export const selectAccessSalonId = ($) => $?.access?.salonId;
export const selectAccessStylistId = ($) => $?.access?.stylistId;
export const selectAccessUserId = ($) => $?.access?.userId;
export const selectAccessPermissionType = ($) => $?.access?.permissionType;
